import { CloudCode } from './cloudcode';

import { Payment, Payout } from '../models/payment';

export class PaymentTasks {

  static pullBusinessPayments(
    successCallback: (payments: Payment[]) => void,
    errorCallback: (msg: string) => void) {

    CloudCode.run('pullBusinessPayments',
      {},
      (payments: Payment[]) => {
        successCallback(payments);
      },
      (msg: string) => {
        errorCallback(msg);
      });
  }

  static getStripeConnectAccountInfo_BusinessLocation(
    businessLocationID: string,
    successCallback: (
      balances: any,
      payouts: Payout[]) => void,
    errorCallback: (msg: string) => void) {

    CloudCode.run('getStripeConnectAccountInfo_BusinessLocation',
      {
        businessLocationID: businessLocationID,
      },
      (obj: any) => {
        successCallback(obj.balances, obj.payouts);
      },
      (msg: string) => {
        errorCallback(msg);
      });
  }

  // static triggerStandardPayout(
  //   accountType: string,
  //   amount: number,
  //   successCallback: () => void,
  //   errorCallback: (msg: string) => void) {

  //   CloudCode.run('createStandardPayout',
  //     {
  //       accountType: accountType,
  //       amount: amount
  //     },
  //     () => {
  //       successCallback();
  //     },
  //     (msg: string) => {
  //       errorCallback(msg);
  //     });
  // }

  // static triggerInstantPayout(
  //   accountType: string,
  //   amount: number,
  //   successCallback: () => void,
  //   errorCallback: (msg: string) => void) {

  //   CloudCode.run('createInstantPayout',
  //     {
  //       accountType: accountType,
  //       amount: amount
  //     },
  //     () => {
  //       successCallback();
  //     },
  //     (msg: string) => {
  //       errorCallback(msg);
  //     });
  // }

  // static setAutomaticPayoutsEnabled(
  //   accountType: string,
  //   enabled: boolean,
  //   successCallback: () => void,
  //   errorCallback: (msg: string) => void) {

  //   CloudCode.run('setAutomaticPayoutsEnabled',
  //     {
  //       accountType: accountType,
  //       enabled: enabled
  //     },
  //     () => {
  //       successCallback();
  //     },
  //     (msg: string) => {
  //       errorCallback(msg);
  //     });
  // }

  static getStripeExpressLoginLink_BusinessLocation(
    businessLocationID: string,
    successCallback: (url: string) => void,
    errorCallback: (msg: string) => void) {

    CloudCode.run('getStripeExpressLoginLink_BusinessLocation',
      {
        businessLocationID: businessLocationID,
      },
      (url: string) => {
        successCallback(url);
      },
      (msg: string) => {
        errorCallback(msg);
      });
  }

}
